import LinkAccount from 'features/advance/screens/lightning/LinkAccount/LinkAccount';
import React from 'react';

export default function LinkAccountPage() {
  return <LinkAccount />;
}
